export const PROFILE_SETTINGS_URL = '/settings/profile'
export const ROOT_URL = '/'
export const GO_TO_WALLET_URL = '/wallet/balance'
